import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BookOpenIcon, LayoutTemplateIcon } from 'lucide-react';
import { scenarios } from '../data/scenarios';
interface DemoBarProps {
  activeId: string;
  onSelect: (id: string) => void;
}
export function DemoBar({
  activeId,
  onSelect
}: DemoBarProps) {
  const {
    pathname
  } = useLocation();
  const onSpecs = pathname === '/specs';
  return <div className="sticky top-0 z-40 border-b border-ink-800 bg-ink-900 px-4 py-2.5" data-id="element-51" data-mp="3h0gtq8r5mgfp">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-x-4 gap-y-2" data-id="element-52" data-mp="3c0kok66q0iyk">
        <span className="text-xs font-semibold uppercase tracking-wide text-ink-400" data-id="element-53" data-mp="37a496gjcan9k">
          Add Payment · States
        </span>
        <div className="flex flex-wrap items-center gap-1.5" data-id="element-54" data-mp="32a9l0kqy8bs7">
          {scenarios.map(scenario => <button key={scenario.id} type="button" onClick={() => onSelect(scenario.id)} aria-pressed={!onSpecs && activeId === scenario.id} title={scenario.caption} className={`rounded-md px-2.5 py-1 text-xs font-medium transition ${!onSpecs && activeId === scenario.id ? 'bg-white text-ink-900' : 'text-ink-300 hover:bg-ink-800 hover:text-white'}`} data-id="element-55" data-mp="3m2mqm7dhzne">
              {scenario.label}
            </button>)}
        </div>
        <Link to={onSpecs ? '/' : '/specs'} className="ml-auto inline-flex items-center gap-1.5 rounded-md border border-ink-700 px-2.5 py-1 text-xs font-semibold text-ink-200 transition hover:bg-ink-800 hover:text-white" data-id="element-56" data-mp="3vvkvxjc1krga">
          {onSpecs ? <LayoutTemplateIcon className="h-3.5 w-3.5" data-id="element-57" data-mp="3ruirmo39pp7g" /> : <BookOpenIcon className="h-3.5 w-3.5" data-id="element-58" data-mp="1l4ky6wveum2s" />}
          {onSpecs ? 'Back to modal' : 'Component specs'}
        </Link>
      </div>
    </div>;
}